import React from "react";
import windshield from "../../../images/Autoform/windshield.png";
import rearwindow from "../../../images/Autoform/rearwindow.png";
import doorwindow from "../../../images/Autoform/doorwindow.png";
import vent from "../../../images/Autoform/vent.png";
import quater from "../../../images/Autoform/quater.png";

const glassOptions = [
    { id: "windshield", label: "Windshield", img: windshield },
    { id: "rear", label: "Rear Window", img: rearwindow },
    { id: "door-window", label: "Door Window", img: doorwindow },
    { id: "vent", label: "Vent Glass", img: vent },
    { id: "quarter", label: "Quarter Glass", img: quater },
];

const positionOptions = [
    { id: "driver-front", label: "Driver Front" },
    { id: "driver-rear", label: "Driver Rear" },
    { id: "passenger-front", label: "Passenger Front" },
    { id: "passenger-rear", label: "Passenger Rear" },
];

const requiresPosition = ["door-window", "vent", "quarter"];

const Step2 = ({ formValues, handleChange, handleNextStep, handlePrevStep, errors }) => {
    const handleGlassSelect = (id) => {
        const updatedValue = requiresPosition.includes(id) && formValues.sidePosition
            ? `${formValues.sidePosition}-${id}`
            : id;

        handleChange({ target: { name: "glassType", value: updatedValue } });
    };

    const handlePositionChange = (pos) => {
        const baseGlass = glassOptions.find(opt => formValues.glassType?.includes(opt.id))?.id;
        const combined = baseGlass ? `${pos}-${baseGlass}` : "";

        handleChange({ target: { name: "glassType", value: combined } });
        handleChange({ target: { name: "sidePosition", value: pos } });
    };

    const selectedGlassId = glassOptions.find(opt =>
        formValues.glassType?.includes(opt.id)
    )?.id;

    return (
        <div className="flex flex-col items-center gap-4 w-full h-full">
            <div className="grid grid-cols-4 gap-4 w-full max-w-4xl">
                {glassOptions.map((glass) => (
                    <button
                        key={glass.id}
                        type="button"
                        onClick={() => handleGlassSelect(glass.id)}
                        className={`flex flex-col items-center p-2 rounded-lg border-2 shadow-md transition-all duration-200 hover:scale-105 ${
                            formValues.glassType?.includes(glass.id)
                                ? "bg-primary text-white border-primary"
                                : "bg-white border-gray-300 hover:border-primary"
                        }`}
                    >
                        <img
                            src={glass.img}
                            alt={glass.label}
                            className="h-auto w-full object-contain mb-2 bg-white rounded-lg"
                        />
                        <span className="text-sm text-center">{glass.label}</span>
                    </button>
                ))}
            </div>

            {/* Position selector shown conditionally */}
            {requiresPosition.includes(selectedGlassId) && (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-4">
                    {positionOptions.map((pos) => (
                        <button
                            key={pos.id}
                            type="button"
                            onClick={() => handlePositionChange(pos.id)}
                            className={`px-3 py-2 rounded-lg border text-sm transition-all duration-200 ${
                                formValues.sidePosition === pos.id
                                    ? "bg-primary text-white border-primary"
                                    : "bg-white border-gray-300 hover:border-primary hover:text-primary"
                            }`}
                        >
                            {pos.label}
                        </button>
                    ))}
                </div>
            )}

            {errors.glassType && <div className="text-red-500">{errors.glassType}</div>}

          
        </div>
    );
};

export default Step2;
